
import { ConfirmDeleteDialog } from "@/components/ui/confirm-delete-dialog";
import type { Database } from "@/integrations/supabase/types";

type OrganizationMember = Database['public']['Tables']['organization_members']['Row'];

interface DeleteMemberDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  memberToDelete: OrganizationMember | null;
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
}

export const DeleteMemberDialog = ({
  isOpen,
  onOpenChange,
  memberToDelete,
  onConfirm,
  isLoading = false,
}: DeleteMemberDialogProps) => {
  return (
    <ConfirmDeleteDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title="Are you sure?"
      description={`This will permanently remove ${memberToDelete?.full_name} from the organization.
        This action cannot be undone.`}
      onConfirm={onConfirm}
      confirmText="Remove Member"
      isLoading={isLoading}
    />
  );
};
